import React, { useState } from 'react';
import { MdExpandMore, MdExpandLess, MdCheckCircle, MdWarningAmber, MdCalendarMonth } from 'react-icons/md';

const ScoreBreakdown = ({ score, risk_level, explanation }) => {
    const [openIndex, setOpenIndex] = useState(null);
    const [sectionOpen, setSectionOpen] = useState(true); // <-- new state

    let breakdownData = [];
    try {
        breakdownData = JSON.parse(explanation)?.breakdown || [];
    } catch { }

    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };
    {/* Helper function to format date. REPLACE WITH RUN DATE */}
    const formatDate = (date) => {
        return date.toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    };

    return (
        <div className="bg-white overflow-hidden">
            {/* Accordion Title */}
            <button
                className="w-full flex items-center justify-between px-6 pt-5 pb-2 border-b border-gray-200 hover:bg-slate-50"
                onClick={() => setSectionOpen((prev) => !prev)}
            >
                <div className="flex items-center gap-2">
                    <h3 className="text-sm font-bold text-gray-700 uppercase tracking-wide">
                        Score Breakdown
                    </h3>
                </div>
                <div className="flex items-center gap-4">
                    <span className="text-xs text-gray-500">
                        {formatDate(new Date())}
                    </span>
                    {sectionOpen ? (
                        <MdExpandLess className="text-gray-500" />
                    ) : (
                        <MdExpandMore className="text-gray-500" />
                    )}
                </div>
            </button>

            {/* Accordion Items */}
            {sectionOpen && (
                <div className="px-4 py-3 space-y-3">
                    {breakdownData.map((item, index) => {
                        const isOpen = openIndex === index;
                        const isNegative = item.score < 0;

                        const icon = isNegative
                            ? <MdCheckCircle className="text-green-500 mr-2" />
                            : <MdWarningAmber className="text-red-400 mr-2" />;

                        return (
                            <div
                                key={index}
                                className={`border border-gray-100 rounded-md transition-all duration-200 ${isOpen ? 'bg-blue-50' : 'bg-slate-50'
                                    }`}
                            >
                                <button
                                    onClick={() => toggleAccordion(index)}
                                    className="w-full flex flex-col sm:flex-row justify-between items-start sm:items-center gap-1 px-2 py-1 hover:bg-slate-100 text-left"
                                >
                                    <div className="flex items-start gap-1 flex-1">
                                        {icon}
                                        <div>
                                            <h5 className="font-semibold text-gray-900 flex items-center gap-2">{item.violation}</h5>
                                            <div className="text-xs text-gray-500 flex items-center flex-1">
                                                <MdCalendarMonth size={14} className="mr-1" />
                                                Date: {item.violation_date}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-between w-full sm:w-auto sm:gap-2 text-right mt-1 sm:mt-0">
                                        <span
                                            className={`text-xs font-semibold px-2 py-0.5 rounded-full border ${item.score < 0
                                                ? 'text-green-700 bg-green-100 border-green-200'
                                                : 'text-red-700 bg-red-100 border-red-200'
                                                }`}
                                        >
                                            {item.score > 0 ? '+' : ''}
                                            {item.score}
                                        </span>
                                        <span className="ml-2">
                                            {isOpen ? (
                                                <MdExpandMore className="text-gray-500 text-xs transition-transform" />
                                            ) : (
                                                <MdExpandLess className="text-gray-500 text-xs transition-transform" />
                                            )}
                                        </span>
                                    </div>
                                </button>
                                {isOpen && (
                                    <div className="px-5 py-3 font-mono text-[11px] text-gray-700 space-y-1 bg-white border-t border-gray-100">
                                        {item.reason && (
                                            <p className="italic text-gray-500 text-sm ml-4">"{item.reason}"</p>
                                        )}
                                        <div className="space-y-1 ml-4">
                                            {item.original_description && (
                                                <div className="flex gap-1">
                                                    <span className="font-semibold min-w-[70px]">Original:</span>
                                                    <span>{item.original_description}</span>
                                                </div>
                                            )}
                                            {item.acd_code && (
                                                <div className="flex gap-1">
                                                    <span className="font-semibold min-w-[70px]">ACD Code:</span>
                                                    <span>{item.acd_code}</span>
                                                </div>
                                            )}
                                            {item.acd_description && (
                                                <div className="flex gap-1">
                                                    <span className="font-semibold min-w-[70px]">ACD Desc:</span>
                                                    <span>{item.acd_description}</span>
                                                </div>
                                            )}
                                            {item.acd_category && (
                                                <div className="flex gap-1">
                                                    <span className="font-semibold min-w-[70px]">Category:</span>
                                                    <span>{item.acd_category}</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default ScoreBreakdown;